export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14629.d233e4b1.jpg";